/**
 * Analytics with Cookie Consent
 *
 * @cookieconsent
 */

import ClassLogger from 'ClassLogger';
import CookieConsent from 'cookieconsent';

class Analytics {
    getClassName() { return 'Analytics'; }
    constructor() {
        let self = this;
        self.logger = ClassLogger(self, true);
        window.Analytics = self;

        let backgroundColor = window.siteConfig.cookiebanner.backgroundcolor;
        let textColor = window.siteConfig.cookiebanner.textcolor;

        window.cookieconsent.initialise({
            'palette': {
                'popup': {
                    'background': '#' + backgroundColor,
                    'text': '#' + textColor
                },
                'button': {
                    'background': 'transparent',
                    'text': '#' + textColor,
                    'border': '#' + textColor
                }
            },
            'position': 'bottom-left',
            'type': 'opt-in',
            'content': {
                'message': window.siteConfig.cookiebanner.message,
                'deny': 'Ablehnen',
                'allow': 'Akzeptieren',
                'link': 'Datenschutzerklärung',
                'href': window.siteConfig.cookiebanner.href
            },
            'revokeBtn': '<div class="cc-revoke cc-bottom cc-left">Datenschutz</div>',

            onInitialise: function (status) {
                if (this.options.type == 'opt-in' && status == 'allow') {
                    self.init();
                }
            },

            onStatusChange: function (status, chosenBefore) {
                if (this.options.type == 'opt-in' && status == 'allow') {
                    self.init();
                }
            }
        });

    }

    init() {
        let self = this;
        self.loadAnalytics();
    }

    loadAnalytics() {
        if (window.siteConfig.ma_siteId === undefined || window.siteConfig.ma_siteId === '') {
            if (window.console && console.warn) console.warn('No Analytics ID set.');
            return;
        }
        let _paq = window._paq = window._paq || [];
        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);
        const u="https://webstats.kid-magdeburg.de/piwik/";
        _paq.push(['setTrackerUrl', u+'matomo.php']);
        _paq.push(['setSiteId', window.siteConfig.ma_siteId]);
        let d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
        g.type='text/javascript'; g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
    }
}

export default Analytics;
